import React from 'react';

import { Service } from 'screens/shared';

const DieselService = () => {
  const routes = {
    mainRoutes: {
      transOil: 'trans-oil',
      engineOil: 'engine-oil',
      gearboxOil: 'gearbox-oil',
      currentError: 'current-error',
      inputStatus: 'input-status',
      outputStatus: 'output-status',
      machineInfo: 'machine-info',
      moduleInfo: 'module-info'
    },
    dpfSoot: 'dpf-soot'
  };

  return <Service routes={routes} />;
};

export default DieselService;



// WEBPACK FOOTER //
// ./src/screens/Diesel/DieselService/DieselService.js